import targetConstants from '@bingads-webui-campaign-legacy/base-targets/viewmodel/targetConstants';

export default {
  getSelectedBidAdjustmentOption(key, dataset, level, useCampaignSettings) {
    if (level === 'campaign' || useCampaignSettings) {
      return dataset[`${key}CampaignBidAdjustment`] >= 0 ? targetConstants.bidAdjustmentIncreaseValue : targetConstants.bidAdjustmentDecreaseValue;
    } else {
      return dataset[`${key}AdgroupBidAdjustment`] >= 0 ? targetConstants.bidAdjustmentIncreaseValue : targetConstants.bidAdjustmentDecreaseValue;
    }
  },
  getBidAdjustmentValue(key, dataset, level, useCampaignSettings) {
    if (level === 'campaign' || useCampaignSettings) {
      return Math.abs(dataset[`${key}CampaignBidAdjustment`]);
    } else {
      return Math.abs(dataset[`${key}AdgroupBidAdjustment`]);
    }
  },
};
